import { SortDirection } from './helpers';

export const sortToObj = (sortStr: string | undefined) => {
  const initialValues = { column: '', direction: undefined };
  if (typeof sortStr !== 'string') {
    return initialValues;
  }
  const [column, direction] = sortStr.split(' ');
  if (typeof column !== 'string' || !['asc', 'desc', undefined].includes(direction)) {
    return initialValues;
  }
  return { ...initialValues, column, direction: direction as SortDirection };
};
